import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import LookupTable from '../../components/lookup/LookupTable';
import '../../components/lookup/lookup.css';

/**
 * Account-wide lookup reference data (CaseId IS NULL). This data applies to
 * the whole account; per-case lookups are managed at /denials/:caseId/lookups.
 */
export default function LookupPage() {
  const navigate = useNavigate();
  const { isAdmin, hasPermission } = useAuth();
  const canWrite = isAdmin || hasPermission('lookup.write');

  return (
    <div className="lookup-page">
      <div className="lookup-header">
        <div>
          <h1>Lookup Reference Data <span className="lookup-scope-tag">Account-wide</span></h1>
          <p>
            Account-global code lookup records (CARC/RARC, ICD-10, MS-DRG, etc.) available to every case.
            Select a category or search to view records. Bulk-load from a .txt/.csv file or ingest the
            CMS MS-DRG pack.
          </p>
        </div>
        {canWrite && (
          <div className="lookup-actions">
            <button type="button" className="lookup-btn" onClick={() => navigate('/admin/lookup/upload')}>
              Upload File
            </button>
            <button type="button" className="lookup-btn" onClick={() => navigate('/admin/lookup/upload-cms-pack')} title="Ingest the CMS MS-DRG Definitions Manual">
              Ingest CMS Pack
            </button>
          </div>
        )}
      </div>

      <LookupTable caseId={null} canWrite={canWrite} />
    </div>
  );
}
